import { render, staticRenderFns } from "./ChangeLanuage.vue?vue&type=template&id=1d7a04be"
import script from "./ChangeLanuage.vue?vue&type=script&lang=js"
export * from "./ChangeLanuage.vue?vue&type=script&lang=js"
import style0 from "./ChangeLanuage.vue?vue&type=style&index=0&id=1d7a04be&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d7a04be')) {
      api.createRecord('1d7a04be', component.options)
    } else {
      api.reload('1d7a04be', component.options)
    }
    module.hot.accept("./ChangeLanuage.vue?vue&type=template&id=1d7a04be", function () {
      api.rerender('1d7a04be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Layout/Components/Header/ChangeLanuage.vue"
export default component.exports